<div id="selection-box">
  <ul>
    <li *ngFor="let integration of sortedIntegrations" class="flex-center-row">
      <input
        id="integration"
        type="checkbox"
        class="arpio-checkbox"
        (input)="toggleIntegration(integration, $event)"
        [checked]="integrationChecked(integration)"
      />
      <div class="integration-type-string">{{ integration.config.getTypeDisplayString() }}:</div>
      <div class="integration-display-name">{{ integration.name }}</div>
    </li>
  </ul>
</div>
